import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { rolesApi as n } from "@maat/api-main";
//#region src/workspaces/useRoleQuery.ts
var r = (r) => t({
	queryKey: e.role(r),
	queryFn: () => n.getRole(r),
	enabled: !!r
});
//#endregion
export { r as useRoleQuery };
